import React, { Suspense, lazy, useEffect, useState } from "react";

//Hooks
import { useScrollLock } from "@magento/peregrine";

//Style
import classes from "./main.module.scss";
import { useUserContext } from "../../../peregrine/context/user";
import { useHistory, useLocation } from "@magento/venia-ui/lib/drivers";
import { useIntl } from "react-intl";
import MyAccountOffcanvas from "../../../../components/MyAccount/Offcanvas/myAccountOffCanvas";
import { GET_CUSTOMER } from "@overrides_venia/peregrine/talons/SignIn/signIn.gql";
import { useAwaitQuery } from "@magento/peregrine/lib/hooks/useAwaitQuery";
import { Offcanvas } from "@Components/Offcanvas/offcanvas";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import CreateAccountPage from "../../../../components/CreateAccountPage";
import { ModalCompleteCustomerData } from "@Components/ModalCompleteCustomerData/modalCompleteCustomerData";
import { useSentry } from "@Src_main/utils/useSentry";
import { useMutation } from "@apollo/client";
import { UPDATECUSTOMERV2 } from "@Src_main/pages/MyAccountData/customerInfo.js";
import { useExponea } from "@Src_main/utils/useExponea";
import { useMagentoConfig } from "@Src_main/utils/useMagentoConfig";
import { usePartnershipQrcode } from "@overrides_venia/peregrine/talons/SignIn/usePartnershipQrcode";
import PromoModalHost from "@Src_main/features/promoModals/PromoModalHost";
import useStores from "@Src_main/utils/useStores";

//Components
const Footer = lazy(() => import("../Footer"));
const Header = lazy(() => import("../Header/header"));
const Login = lazy(() => import("../../../../components/Login"));
const ForgotPassword = lazy(() => import("../ForgotPassword"));
const CookieBanner = lazy(() => import("../../../../components/CookieBanner/cookieBanner"));
const Main = props => {
  const {
    children,
    isMasked
  } = props;
  const history = useHistory();
  const {
    trackAllEvent
  } = useExponea();
  useSentry();
  useMagentoConfig();
  useStores({
    refreshAvailability: true
  });
  const {
    isMobile
  } = useWindowSize();
  const [isModalCompleteCustomerDataOpen, setIsModalCompleteCustomerDataOpen] = useState(false);
  const [handleUpdateCustomer] = useMutation(UPDATECUSTOMERV2);
  useScrollLock(isMasked);
  const [{
    currentUser,
    isUserComplete,
    isSignedIn,
    isSignedInOnSessionStart,
    hasUserMandatoryFields,
    hasUserOptionalFields,
    isApp
  }, {
    getUserDetails
  }] = useUserContext();
  const location = useLocation();
  const {
    formatMessage
  } = useIntl();
  const fetchUserDetails = useAwaitQuery(GET_CUSTOMER);
  usePartnershipQrcode({
    isSignedIn,
    currentUser,
    getUserDetails
  });

  // request data from server
  useEffect(() => {
    if (isSignedIn) getUserDetails({
      fetchUserDetails
    });
  }, [fetchUserDetails, getUserDetails, isSignedIn]);
  useEffect(() => {
    if (currentUser && currentUser.email) {
      exponea.identify({
        account_id: currentUser.email,
        email: currentUser.email
      });
      trackAllEvent("customer_logged");
      if (isSignedIn && (hasUserMandatoryFields === false || hasUserOptionalFields === false) && isSignedInOnSessionStart === false && !location.pathname.includes(formatMessage({
        id: "url.key.loyalty.data"
      }))) {
        setIsModalCompleteCustomerDataOpen(true);
      }
    }
  }, [currentUser]);
  useEffect(() => {
    window.isSignedIn = isSignedIn;
    if (isSignedIn === false && isApp) {
      history.replace(formatMessage({
        id: "url.key.login"
      }));
    }
    return () => {
      delete window.isSignedIn;
    };
  }, [isSignedIn]);
  const showOffcanvasRegistration = true; // !location.pathname.includes(formatMessage({ id: "url.key.signup" }));

  const showOffcanvasLogin = true; // !location.pathname.includes(formatMessage({ id: "url.key.login" }));

  const loyaltyOffcanvases = currentUser.email && isSignedIn ? /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-my-account",
    classes: classes
  }, /*#__PURE__*/React.createElement(MyAccountOffcanvas, {
    range_seeds: "500"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, showOffcanvasLogin ? /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-login-dx",
    classes: classes,
    duration: 200
  }, /*#__PURE__*/React.createElement(Login, {
    isOffCanvas: true,
    backFunction: () => {
      UIkit.offcanvas("#offcanvas-login-dx").hide();
    }
  })) : null, showOffcanvasRegistration ? /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-registration-dx",
    className: classes.offcanvasRegistration,
    classes: classes,
    overflowHidden: !isMobile
  }, isMobile ? /*#__PURE__*/React.createElement(CreateAccountPage, {
    isOffCanvas: true,
    backFunction: () => {
      UIkit.offcanvas("#offcanvas-registration-dx").hide();
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "uk-flex"
  }, /*#__PURE__*/React.createElement(CreateAccountPage, {
    isOffCanvas: true,
    backFunction: () => {
      UIkit.offcanvas("#offcanvas-registration-dx").hide();
    },
    showHeader: false
  }))) : null, /*#__PURE__*/React.createElement(Offcanvas, {
    id: "offcanvas-pwdforgot-dx",
    classes: classes
  }, /*#__PURE__*/React.createElement(ForgotPassword, null)));
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement("main", {
    className: classes.root
  }, isMobile ? null : /*#__PURE__*/React.createElement(Header, null), loyaltyOffcanvases, /*#__PURE__*/React.createElement("div", {
    className: classes.pageSize
  }, children), isMobile ? null : /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(CookieBanner, null), /*#__PURE__*/React.createElement(PromoModalHost, null), isSignedIn ? /*#__PURE__*/React.createElement(ModalCompleteCustomerData, {
    isOpen: isModalCompleteCustomerDataOpen,
    setIsOpen: setIsModalCompleteCustomerDataOpen
  }) : null));
};
export default Main;